module.exports = __webpack_public_path__ + "img/3.0daf6116.png";